controllers.controller('ClosedTradeController', [
    '$scope', '$state', '$filter', '$ionicModal', '$ionicLoading', '$timeout', '$ionicPopup',
    'config', 'constants', 'Utils', 'API', 'UserService', 'InvestCalcService', 'LocaleService', 'ClosedTradeService',
    'ServerTimeService', 'UserControl',
    function ($scope, $state, $filter, $ionicModal, $ionicLoading, $timeout, $ionicPopup,
              config, Const, Utils, API, UserService, InvestCalcService, LocaleService, ClosedTradeService,
              ServerTimeService, UserControl) {

        $scope.trades = [];
        $scope.user = UserService.get();

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });
        $scope.clientTimeZone = ServerTimeService.timeZoneOffset >= 0 ? '+' + ServerTimeService.timeZoneOffset.toString() : ServerTimeService.timeZoneOffset.toString();
        $scope.constants = Const;
        $scope.showConvertToUsd = Const["showConvertToUsd"] || false;
        $scope.selectedRange = "day";

        $scope.tradeActions = [
            {label: LocaleService.translation.allTypes, id: 'all'},
            {label: LocaleService.translation.trades, id: 'trades'},
            {label: LocaleService.translation.balance, id: 'balance'},
            {label: LocaleService.translation.credit, id: 'credit'},
            {label: LocaleService.translation.other, id: 'other'},
        ];

        $scope.filter = {
            tradeAction: _.find($scope.tradeActions, {id: 'trades'}) || $scope.tradeActions[0]
        }

        $scope.toggleCategory = function (range) {
            $scope.selectedRange = range;
            $scope.trades.length = 0;
            filterTrades(range);
        };

        $scope.toggleCategory($scope.selectedRange);

        function filterTrades(range) {
            if ($scope.user && !Const['skipRegistrationStateCheck']) {
                switch ($scope.user.registrationState) {
                    case Const.userState.initial:
                        return $state.go('signupPersonalProfile', {cache: false});
                    case Const.userState.personal:
                        return $state.go('signupQuestionnaire', {cache: false});
                }
            }
            $scope.loadingMessage = LocaleService.translation.loading_closed_trades;
            $ionicLoading.show({templateUrl: 'templates/directives/message-spinner.html', scope: $scope});

            $scope.trades = [];

            return ClosedTradeService.collection && ClosedTradeService.getHistory(range)
                .then(Utils.wait(500))
                .then(function () {
                    $ionicLoading.hide();
                    if ($scope.filter.tradeAction.id === 'all') {
                        $scope.trades = ClosedTradeService.collection.getAllTrades();
                    } else {
                        $scope.trades = ClosedTradeService.collection.find({tradeAction: $scope.filter.tradeAction.id})
                    }
                });
        }


        $scope.showFilter = function () {
            var myPopup = $ionicPopup.show({
                templateUrl: 'templates/tradeActionFilter.html',
                title: '<span class="roboto">' + LocaleService.translation.filterClosedTrades + '</span>',
                scope: $scope,
                buttons: [
                    {
                        text: LocaleService.translation.cancel,
                        type: 'button-block'
                    },
                    {
                        text: LocaleService.translation.filter,
                        type: 'button-block button-full',
                        onTap: function (e) {
                            e.preventDefault();
                            if ($scope.filter.tradeAction.id === 'all') {
                                $scope.trades = ClosedTradeService.collection.getAllTrades();
                            } else {
                                $scope.trades = ClosedTradeService.collection.find({tradeAction: $scope.filter.tradeAction.id})
                            }
                            myPopup.close();
                        }
                    }
                ]
            });
        };

        function clear() {
            $scope.trades = [];
            $scope.user = null;
        }

        $scope.$on('$ionicView.beforeEnter', function () {
            $scope.state = UserControl.getState();
            if ($scope.state) {
                return $state.go($scope.state, {cache: false});
            }
            return UserService.kycCheck();
        });

        $scope.$on('$ionicView.afterLeave', clear);
        $scope.$on('$ionicView.unloaded', clear);
        $scope.$on('clear', clear);

    }]);
